import { DeviceType } from "../devices";

import { SortDirection } from "../types";

export enum presenceStatuses {
  active = "present",
  away = "away",
  discharged = "discharged",
}

export type Resident = ResidentBase & {
  id: string;
  nodeId: number;
  nodePresence: presenceStatuses;
  birthdate: string | undefined;
  gender: gender | undefined;
  picture?: string;
  lastUpdate: string;
};

export type MoveResidentWithDeviceResponceDTO = {
  id: string;
  href: string;
  resourceNodeId: number;
  resourceName: ResourceName;
  previousResourceNodeId: number;
};

export enum gender {
  male = "male",
  female = "female",
  notDeclared = "notDeclared",
}

export enum ResourceName {
  devices = "devices",
  residents = "residents",
}

type ResidentBase = {
  firstName: string;
  lastName: string;
  devices?: string[];
  devicesMinimized?: DeviceMinimizedMap;
};

export type DeviceMinimizedMap = {
  [key: string]: DeviceMinimized;
};
export type DeviceMinimized = {
  type: DeviceType;
  room: string;
  bed: string;
};

export enum VitalIdType {
  HR = "HR",
  RR = "RR",
  HRV = "HRV",
  SV = "SV",
  SPO = "SPO",
  TEMP = "TEMP",
}

export type IFiltersTypeMap = {
  [key in string]: boolean;
};

export type ResidentMap = {
  [key: string]: Resident;
};

export type AppStateResidents = {
  residents: ResidentMap;
  isLoading: boolean;
  isPerformingUserAction: boolean;
  settings: ResidentsSettings;
};
export type ResidentSort = {
  type: ResidentSortType;
  direction: SortDirection;
};

export enum ResidentSortType {
  RoomBed = "RoomBed",
  Name = "Name",
  Block = "Block",
}

export enum residentInclude {
  statuses = "statuses",
  vitals = "vitals",
  nodes = "nodes",
  devices = "devices",
  alerts = "alerts",
  rules = "rules",
}

export type residentsReqOptions = {
  [key: string]: number | string | residentInclude[];
  include: residentInclude[];
  limit?: number;
  offset?: number;
  filterBy?: string;
};

export const defaultOptions: residentsReqOptions = {
  include: [
    residentInclude.alerts,
    residentInclude.statuses,
    residentInclude.nodes,
    residentInclude.devices,
    residentInclude.rules,
    residentInclude.statuses,
  ],
};

export enum FiltersType {
  RESIDENTS_ACTIVE = "RESIDENTS_ACTIVE",
  RESIDENTS_AWAY = "RESIDENTS_AWAY",
  RESIDENTS_DISCHARGED = "RESIDENTS_DISCHARGED",
  DEVICE_VITALS = "DEVICE_VITALS",
  DEVICE_BIOPATCH = "DEVICE_BIOPATCH",
  DEVICE_WATCH = "DEVICE_WATCH",
  DEVICE_NO = "DEVICE_NO",
  DEVICE_STATUS_ACTIVE = "DEVICE_STATUS_ACTIVE",
  DEVICE_STATUS_NOT_ACTIVE = "DEVICE_STATUS_NOT_ACTIVE",
  UNPLUGGED = "UNPLUGGED",
  TURN_OFF = "turnOff",
  BatteryLevelLow = "BatteryLevelLow",
  BatteryLevelEmpty = "BatteryLevelEmpty",
  MAINTENANCE = "MAINTENANCE",
  LOW_WIFI = "lowWifi",
  NO_WIFI = "noWifi",
  NO_BLUETOOTH = "NO_BLUETOOTH",
  USER_NEARBY_IN_BED = "userNearbyInBed",
  USER_NEARBY_OUT_BED = "userNearbyOutBed",
  USER_NEARBY_ROOM = "userNearbyOutRoom",
}

export type FallDetectedRuleSocket = {
  nodeId: number;
  state: boolean;
  residentId: string;
};

export type EpilepsyRuleSocket = {
  nodeId: number;
  state: boolean;
  residentId: string;
};

export type ResidentsSettings = {
  searchValue?: string;
  sort?: ResidentSort;
  filters?: IFiltersTypeMap;
  selectedResidents?: string[];
  showDischarged?: boolean;
};

export const rbmDevice = (resident: Resident): string => {
  if (resident === undefined) return "";
  return resident.devices.find((el) => el?.indexOf("VT") !== -1) || "";
};

export const IMAGE_STUB: Resident = {
  firstName: "",
  lastName: "",
  devices: [],
  devicesMinimized: {},
  id: "",
  nodeId: -1,
  birthdate: "",
  gender: gender.notDeclared,
  nodePresence: presenceStatuses.active,
  lastUpdate: new Date().toISOString(),
};

export type changeNodePresenceDTO = {
  nodePresence: presenceStatuses;
  residentIds: string[];
};

export type changeNodePresenceSocket = {
  nodePresenceType: presenceStatuses;
  residentIds: string[];
};

export type MoveResidentWithDevicesBySocketDTO = {
  deviceIds: string[];
  toNodeId: number;
  residentId: string;
  fromNodeId: number;
};
